
  // 本文件由 /task/generateHead.js 生成，请勿手动修改文件内容
  // 本文件信息为静态页面id列表
  // v2: 统一走 UniversalDetail 详情页，不再区分静态/动态
  const mixins = {
    methods: {
      handleServiceRoute(serviceId, serviceStatus, serviceTopProductId) {
        if (serviceId && serviceId !== null && serviceId !== undefined) {
          this.$router.push({
            path: '/serviceDetail/' + serviceId,
          });
        }
      }
    }
  }
  export default mixins;



// WEBPACK FOOTER //
// ./src/mixins/staticPagesList.js